var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fades" } }, [
    _vm.show
      ? _c(
          "div",
          {
            staticClass: "leon_alter",
            class: _vm.typeId ? "leon_alter" + _vm.typeId : "",
            staticStyle: { "z-index": "2001" }
          },
          [
            _c(
              "div",
              {
                staticClass: "leon_alter_box",
                class: { remaidBox: _vm.code && _vm.text.length > 200 }
              },
              [
                _c("div", { staticClass: "title bold" }, [
                  _vm._v(_vm._s(_vm.title))
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "text",
                    class: { remaid: _vm.code && _vm.text.length > 200 }
                  },
                  [_vm._v(_vm._s(_vm.text))]
                ),
                _vm._v(" "),
                _vm.img
                  ? _c("div", { staticClass: "img" }, [
                      _c("img", {
                        attrs: { src: _vm.img, alt: "", srcset: "" }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "btn" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", round: "" },
                        on: { click: _vm.yesBtn }
                      },
                      [_vm._v(_vm._s(_vm.yesTxt))]
                    )
                  ],
                  1
                )
              ]
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-425c9b30", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-425c9b30","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/plugin/leonAlter/src/main.vue
// module id = null
// module chunks = 